import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

interface Props {
  opacity: number;
}

const OpacityAnimationDiv = styled.div<Props>`
  opacity: ${(props) => props.opacity};
`;

export default withAnimation(OpacityAnimationDiv);
